import React from "react";
import InputMask from "react-input-mask";
import { PHONE_MASK } from "../../constants/formats";

export const PhoneInput = ({ input, label, meta: { touched, error, warning, asyncValidating } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-3'>{label}</label>
        <div className='controls col-sm-9'>
            <InputMask {...input} placeholder={label} type='tel' mask={PHONE_MASK}
                style={{ width: '400px', resize: 'vertical' }}
                className='form-control' />
            {asyncValidating && <span>Проверка...</span>}
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

export const UnstyledPhoneInput = ({ input, label, type, meta: { touched, error } }) => (
    <div>
        {label && <label className='control-label'>{label}</label>}
        <InputMask {...input}
            placeholder={label}
            type='tel'
            mask={PHONE_MASK}
            style={{ resize: 'vertical' }}
            className='form-control' />
        {touched && error && <span style={{ color: 'red' }}>error</span>}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/common/PhoneInput.jsx